import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { MessageDialogComponent } from '../components/message/message-dialog.component';
import {
  MessageButtonDef,
  MessageButtons,
  MessageContentType,
  MessageDialogOptions,
} from '../models/message.model';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private dialog = inject(MatDialog);

  /**
   * Opens an alert message box with customizable buttons (Defaults to Close).
   */
  async showAlert(
    title: string,
    message: MessageContentType,
    buttons: MessageButtons | MessageButtonDef[] = MessageButtons.Close,
  ): Promise<any> {
    const options: MessageDialogOptions = {
      title,
      message,
      type: 'alert',
      buttons,
    };

    return await firstValueFrom(
      this.dialog
        .open(MessageDialogComponent, {
          data: options,
          width: '400px',
          disableClose: true,
          autoFocus: false,
        })
        .afterClosed(),
    );
  }

  /**
   * Opens a confirmation dialog returning the resolved button value.
   */
  async showConfirm(options: MessageDialogOptions): Promise<any> {
    const dialogOptions: MessageDialogOptions = {
      type: 'confirm',
      buttons: MessageButtons.YesNo,
      ...options,
    };

    const result = await firstValueFrom(
      this.dialog
        .open(MessageDialogComponent, {
          data: dialogOptions,
          width: '400px',
          disableClose: true,
          autoFocus: false,
        })
        .afterClosed(),
    );

    return result ?? 'no';
  }
}
